import { render } from "./TermAgreement2.vue?vue&type=template&id=2bba1fcb"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__